'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('survey-public', {
      url: '/public/survey/:id',
      template: '<survey-public></survey-public>'
    });
}



// WEBPACK FOOTER //
// ./client/app/survey/public/survey-public.routes.js